import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TypeAppel } from 'src/app/model/gestion/gestion';
import { WebConfigurationService } from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class GestionTypesAppelsService extends WebConfigurationService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
  * GET the 'type appels sav' datas
  * 
  */
  public getTypeAppelsSavList(): Observable<any> {
    return this.authGetObs<TypeAppel[]>(this.getTypesAppelsUrl());
  }

  /**
* POST a type d'appel
* @returns  an Observable
*/
  public postAppelSav(newAppelSav: TypeAppel): Observable<any> {
    return this.http.post<TypeAppel>(this.getTypesAppelsUrl(), newAppelSav, {
      headers: this.createHeaders( )
    });
  }

  /** UPDATE type appel */
  public editAppelSav(id: number, body: TypeAppel) {
    let url = this.getTypesAppelsUrl() + '/update/' + id;
    return this.authPutObs<TypeAppel>(url, body);
  }

  /** DELETE type appel */
  public deleteAppelSav(id: number, body : TypeAppel) {
    let url = this.getTypesAppelsUrl() + '/delete/' + id;
    return this.authPutObs<TypeAppel>(url, body);
  }

}
